import { Plugin } from 'prosemirror-state';
import { ContentNodeWithPos } from 'prosemirror-utils';

import { AddMenuCallout, Callout as CalloutIcon } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock, setPlaceholder } from '../../../utils/menus';
import { NODE_NAME } from '../consts';

function plugins({ t }: EditorOptions): Plugin[] {
  return [
    new Plugin({
      view: (editorView) => {
        setPlaceholder(editorView, NODE_NAME, (_contentNode: ContentNodeWithPos) =>
          t('Lygo:Callout'),
        );

        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.callout.title') as string,
            icon: CalloutIcon,
            addMenuIcon: AddMenuCallout,
            addMenuItemType: addMenuItemType.basic_blocks,
            description: t('Lygo:Menu.callout.description') as string,
            searchWords: ['callout', 'highlight', 'basic'],
            isText: true,
          },
        ]);
        return {};
      },
    }),
  ];
}

export default plugins;
